import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import genericStyles from "../../Styles/genericStyles.module.css";
import { TablesIds } from "../../Utils/Constants";
import { EComponentTypes, ETableEditAction } from "../../Utils/Enums";
import { Filter } from "../../Utils/Types";
import { endpoints } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import Filters from "../Widgets/Filters";
import {
  ClientModel,
  OrderModel,
  ProductModel,
  UserModel,
} from "../../Utils/Models";
import {
  fetchProducts,
  formatDate,
  getFullName,
  OrderStatus,
} from "../../Utils/Utils";
import useCustomMemo from "../../Hooks/useCustomMemo";
import { getFromCacheOrFetch } from "../../Utils/getFromCacheOrFetch";

export default function ScheduledExamsByType() {
  const { type } = useParams<{ type: string }>();
  const [products, setProducts] = useState<ProductModel[]>([]);
  const [triggerReload, setTriggerReload] = useState(false);

  const memo = useCustomMemo();
  const instructorId = localStorage.getItem("userId");

  useEffect(() => {
    let mounted = true;

    getFromCacheOrFetch<any[]>({
      cacheKey: "products",
      storage: memo.storage,
      setStorage: memo.setStorageData,
      fetcher: fetchProducts(),
      isValid: (data) => Array.isArray(data) && data.length > 0,
    }).then((data) => {
      if (mounted) {
        setProducts(data?.filter((p) => p.isCertificate == false) || []);
      }
    });

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTriggerReload(!triggerReload);
  }, [type]);

  const columns = [
    {
      name: "orderDetails",
      label: Vocabulary.id,
      options: {
        customBodyRender: (order: OrderModel) => {
          return order?.orderNumber;
        },
      },
    },
    {
      name: "createdAt",
      label: Vocabulary.programedDate,
      options: {
        customBodyRender: (date: Date) => {
          return formatDate(date);
        },
      },
    },
    {
      name: "clientDetails",
      label: Vocabulary.cursant,
      options: {
        sortField: "clientDetails.firstName",
        customBodyRender: (client: ClientModel) => {
          return getFullName(client);
        },
      },
    },
    {
      name: "orderDetails",
      label: Vocabulary.category,
      options: {
        sortField: "orderDetails.product.name",
        customBodyRender: (order: OrderModel) => {
          return order?.product?.name;
        },
      },
    },
    {
      name: "examDate",
      label: Vocabulary.examDate,
      options: {
        customBodyRender: (date: Date) => {
          return (
            <Box
              sx={{
                fontWeight: 700,
                color: "#d32f2f",
                fontSize: "0.95rem",
              }}
            >
              {formatDate(date)}
            </Box>
          );
        },
      },
    },
    {
      name: "instructorUserDetails",
      label: Vocabulary.instructor,
      options: {
        sortField: "instructorUserDetails.firstName",
        customBodyRender: (instructor: UserModel) => {
          return getFullName(instructor);
        },
      },
    },
  ];

  const filters: Filter[] = [
    {
      property: "productId",
      autocompleteFilterProperty: "_id",
      label: Vocabulary.category,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: null,
      defaultValue: null,
      options: products,
    },
  ];

  const getTitle = () => {
    if (type === "practical") {
      return `${Vocabulary.scheduledExams} - ${Vocabulary.practical}`;
    } else if (type === "theoretical") {
      return `${Vocabulary.scheduledExams} - ${Vocabulary.theoretical}`;
    }
    return Vocabulary.scheduledExams;
  };

  return (
    <div className={genericStyles.mainContainer}>
      <Filters filters={filters} filterWidth={2} defaultOpen />
      <MUIDataTableCustomStyle
        buttons={[]}
        onEditAction={ETableEditAction.NONE}
        title={getTitle()}
        id={TablesIds.examsTable}
        hideAddButton={true}
        columns={columns}
        CRUDEndPoint={`${
          endpoints.exams.main
        }/scheduled-by-instructor/${instructorId}/${
          OrderStatus[type as keyof typeof OrderStatus]
        }`}
        hideEditButton={true}
        hideDeleteButton={true}
        triggerReload={triggerReload}
      />
    </div>
  );
}
